import React from 'react';
import { Tooltip } from 'react-bootstrap';

class MyTooltip extends React.Component{
    render(){
        return (
            <Tooltip 
                {...this.props}
                // arrowOffsetTop="50%"
                style={{'zIndex':'99999'}}
            />
        );
    }
}
export default MyTooltip;


// WEBPACK FOOTER //
// ./src/app/components/BaseComponent/Wrapper/Tooltips.js